/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetProjectStorageLimitDTO
 */
export interface SetProjectStorageLimitDTO {
    /**
     * 
     * @type {number}
     * @memberof SetProjectStorageLimitDTO
     */
    maxStorageSize: number;
}

/**
 * Check if a given object implements the SetProjectStorageLimitDTO interface.
 */
export function instanceOfSetProjectStorageLimitDTO(value: object): value is SetProjectStorageLimitDTO {
    if (!('maxStorageSize' in value) || value['maxStorageSize'] === undefined) return false;
    return true;
}

export function SetProjectStorageLimitDTOFromJSON(json: any): SetProjectStorageLimitDTO {
    return SetProjectStorageLimitDTOFromJSONTyped(json, false);
}

export function SetProjectStorageLimitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetProjectStorageLimitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'maxStorageSize': json['maxStorageSize'],
    };
}

export function SetProjectStorageLimitDTOToJSON(value?: SetProjectStorageLimitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxStorageSize': value['maxStorageSize'],
    };
}

